/* lua.js generated code 0.3.0 */

var PushBounceAnim = require("clover/panel/component/common/uiButtonAnims/PushBounceAnim")
var GameGuideAnims = require("clover/gameGuide/GameGuideAnims")
var StrategyFromShareConfirmPanel = xClass("StrategyFromShareConfirmPanel", BasePanel, function () {
    // WARN: maybe multi result
    return cc.CSLoader.createNode("cocos/panel_stategy_prompt_panel_stategy_prompt3.csb")
})
StrategyFromShareConfirmPanel.prototype.ctor = function (okCb, cancelCb, levelId) {
    var self = this;
    self.okCb = okCb;
    self.cancelCb = cancelCb;
    self.levelId = levelId;
    self.bind(self);
    BasePanel.prototype.init.call(self);
    self.init();
    self.popup();
}
StrategyFromShareConfirmPanel.prototype.init = function () {
    var self = this;
    self.setLocalZOrder(1002);
    
    var cancel = UIGroupButton.create(self.getChildByName("btn2"));
    PushBounceAnim.create(cancel);
    var txt = cancel.getChildByName("label");
    txt.setString(getText("leveltip.start.comfirm.cancel"));
    var pos = txt.getPosition();
    txt.setPosition(cc.pAdd(pos, cc.p(20, 0)));

    cancel.on(UIButtonEvent.Click, function () {
        self.onClose();
        self.cancelCb();
    })
    var txt = self.getChildByName("txt");
    var str = getText("leveltip.start.comfirm.text");
    str = str.replace("{leveltip.level}", self.levelId);
    txt.setString(str);
    

    var ok = UIGroupButton.create(self.getChildByName("btn"));
    PushBounceAnim.create(ok);
    var txt = ok.getChildByName("label");
    txt.setString(getText("leveltip.start.comfirm.ok"));
    // button.getChildByName("label").setPositionX(-45);
    ok.on(UIButtonEvent.Click, function () {
        DCAssist.userTrack("levelTip", "tip_share_start", {"num": self.levelId});
        if (self.okCb){
            self.okCb();
        }
        self.onClose();
    })

    self.setScale(self.getReferenceScale());
}

StrategyFromShareConfirmPanel.prototype.popup = function () {
    var self = this
    var targetScale = self.getScale()
    self.setScale(0)
    var time = 7 / 30
    PopoutManager.getInstance().addWithBgFadeIn(self, true, false)
    var dH = display.height-GamePlayConfig_Design_Height;
    var targetPos = cc.pAdd(cc.p(self.getPosition()), cc.p(55, 850 + dH/2));
    var pos_O = cc.p(display.width / 2, display.height / 2)
    var startPoint = cc.pMul(cc.pSub(targetPos, pos_O), 0.23)
    self.setScale(0.23)
    self.setPosition(cc.p(pos_O.x + startPoint.x, pos_O.y + startPoint.y))
    self.runAction(cc.Sequence.create(cc.EaseSineOut.create(cc.Spawn.create(cc.ScaleTo.create(time, targetScale), cc.MoveTo.create(time, targetPos)))))
    return self
}

StrategyFromShareConfirmPanel.prototype.onCleanup = function () {
    ResManager.release(["packed/StrategyPrompt.pack"]);
}

module.exports = StrategyFromShareConfirmPanel;
